import { DI } from '@aurelia/kernel';
export const IDomRenderer = DI.createInterface('IDomRenderer');
export const IScrollerObsererLocator = DI.createInterface('IScrollerObsererLocator');
export const ICollectionStrategyLocator = DI.createInterface('ICollectionStrategyLocator');
